import { defineMessages } from 'react-intl';

export const transferOrderEmptyStateMessages = defineMessages({
  emptyStateHeader: {
    id: 'PY/lhA',
    defaultMessage: 'Optimize Stock Across Warehouses with Transfer Orders',
    description: 'Header text for transfer order feature gate empty state',
  },
  emptyStateDescription: {
    id: 'C9ms4h',
    defaultMessage:
      'Transfer orders help you move inventory between your warehouses efficiently. Balance stock levels, prepare for seasonal demand, and ensure the right products are in the right locations.',
    description: 'Description text explaining transfer order benefits',
  },
  emptyStateSubDescription: {
    id: 'AQ1HAt',
    defaultMessage:
      'With transfer orders, you can track shipments between facilities, reduce shipping costs by positioning inventory closer to customers, and improve fulfillment times.',
    description: 'Additional description text for transfer order benefits',
  },
  upgradeToAccess: {
    id: 'M0Pbuy',
    defaultMessage: 'Upgrade your plan to access Transfer Orders',
    description: 'Promotional banner header for transfer order upgrade',
  },
  unlockFeature: {
    id: 'RjWmbQ',
    defaultMessage: 'Unlock advanced inventory management tools to grow your business',
    description: 'Promotional banner subheader for transfer order upgrade',
  },
  upgradeNow: {
    id: 'UVAfN8',
    defaultMessage: 'Upgrade Now',
    description: 'Button text for upgrading to access transfer orders',
  },
});
